import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmt } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Empty } from "@/components/ui-bits";

export const Team = () => {
  const { user } = useAuth();
  const [t, setT] = useState(null);
  const [f, setF] = useState({ email: "", name: "" });
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => api.get("/team").then((r) => setT(r.data)), []);
  useEffect(() => { load(); }, [load]);
  if (!t) return null;
  const copy = (link) => { navigator.clipboard?.writeText(link); toast.success("Invite link copied"); };
  const invite = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const r = await api.post("/team/invites", { email: f.email.trim(), name: f.name.trim() || null }); setF({ email: "", name: "" }); toast.success(r.data.sendStatus === "sent" ? "Invite emailed" : "Invite created — email couldn't be sent, copy the link and share it"); load(); }
    catch (ex) { toast.error(errMsg(ex)); } finally { setBusy(false); }
  };
  const act = async (fn, ok) => { try { await fn(); if (ok) toast.success(ok); load(); } catch (ex) { toast.error(errMsg(ex)); } };
  return (
    <div className="panel" data-testid="team-panel">
      <div className="ph"><h3>Team · {t.members.length} coach{t.members.length !== 1 ? "es" : ""} share this workspace</h3>{!t.isOwner && <span className="chip gray" data-testid="team-not-owner">owner manages the team</span>}</div>
      {t.members.map((m) => (
        <div className="sess" key={m.id} data-testid={`team-member-${m.id}`}>
          <div className="sb"><div className="st" style={{ fontSize: 13 }}>{m.name}{m.id === user.id && <span className="ss"> · you</span>}</div><div className="ss">{m.email}{m.phone ? ` · ${m.phone}` : ""}</div></div>
          <span className={`chip ${m.isOwner ? "ok" : "gray"}`} data-testid={`team-role-${m.id}`}>{m.isOwner ? "owner" : "coach"}</span>
          {t.isOwner && !m.isOwner && <button className="btn sm danger" onClick={() => window.confirm(`Remove ${m.name} from the workspace?`) && act(() => api.delete(`/team/members/${m.id}`), "Coach removed")} data-testid={`team-remove-${m.id}`}>Remove</button>}
        </div>
      ))}
      {t.invites.length > 0 && <label style={{ marginTop: 12 }}>Pending invites</label>}
      {t.invites.map((i) => (
        <div className="sess" key={i.id} data-testid={`team-invite-${i.id}`}>
          <div className="sb"><div className="st" style={{ fontSize: 13 }}>{i.name || i.email}</div><div className="ss">{i.email} · expires {fmt(i.expiresAt, { day: "numeric", month: "short" })}{i.sendStatus === "failed" ? " · email not delivered — share the link" : ""}</div></div>
          <button className="btn sm g" onClick={() => copy(i.link)} data-testid={`team-invite-copy-${i.id}`}>Copy link</button>
          {t.isOwner && <button className="btn sm g" onClick={() => act(() => api.post(`/team/invites/${i.id}/resend`), "Invite resent")} data-testid={`team-invite-resend-${i.id}`}>Resend</button>}
          {t.isOwner && <button className="btn sm danger" onClick={() => act(() => api.delete(`/team/invites/${i.id}`), "Invite revoked")} data-testid={`team-invite-revoke-${i.id}`}>Revoke</button>}
        </div>
      ))}
      {t.isOwner && (
        <form onSubmit={invite} style={{ marginTop: 14 }} data-testid="team-invite-form">
          <label>Invite a co-coach by email</label>
          <div className="frow" style={{ gridTemplateColumns: "1.4fr 1fr auto", alignItems: "end" }}>
            <input required type="email" placeholder="coach@studio.com" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="team-invite-email-input" />
            <input placeholder="Name (optional)" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="team-invite-name-input" />
            <button className="btn sm" disabled={busy} data-testid="team-invite-button">{busy ? "Sending…" : "Send invite"}</button>
          </div>
          <div className="ss">They get a 7-day link to set their password and land in this exact workspace — same clients, schedule, programs and messages.</div>
        </form>
      )}
      {t.members.length === 1 && t.invites.length === 0 && !t.isOwner && <Empty>Only the owner is here so far.</Empty>}
    </div>
  );
};
